import React from 'react'
import { EliminateQueryCanonical } from 'src/@legacy/@core/components/SEOMeta/CanonicalMeta'
import { LINK_URL_REGISTER } from 'src/@legacy/utilities/LinkURL'
import RegisterWrapper from 'src/@legacy/wrapper/register'
import withAppProvider from 'src/@legacy/layout/hoc/withAppProvider'
import PublicPageMeta from 'src/@legacy/@core/components/SEOMeta/PublicPageMeta'

const RegisterPage = () => {
  return (
    <>
      <PublicPageMeta
        title="Đăng ký & Tạo tài khoản nhà tuyển dụng với freeC"
        description="Đăng ký để trải nghiệm tất cả các tính năng tuyển dụng nâng cao trong nền tảng freeC miễn phí. Click tạo tài khoản ngay."
        url={`${process.env.NEXT_PUBLIC_APP_DOMAIN}${LINK_URL_REGISTER}`}
      />
      <RegisterWrapper />
    </>
  )
}
export default withAppProvider(RegisterPage)
